import { BlobStorageModel } from '../gql-types.generated';

/**
 * Gets the first version (lowest version number) from a list of blob storage versions
 * @param fileVersions - Array of blob storage file versions
 * @returns The blob storage version with the lowest version number, or undefined if no versions exist
 */
export const getFirstBlobStorageVersion = (
    fileVersions: BlobStorageModel[] | undefined
): BlobStorageModel | undefined => {
    if (!fileVersions || fileVersions.length === 0) {
        return undefined;
    }
    
    return fileVersions.reduce((prev, current) => {
        return (current.version < prev.version) ? current : prev;
    });
};